module.exports = __webpack_public_path__ + "591e105f90e65c673983a34ca5df32f1.mp4";


//////////////////
// WEBPACK FOOTER
// ./app/assets/video/tray_nl.mp4
// module id = 943
// module chunks = 4